import React from 'react';
import { Flex } from 'lib/components/styles/layout';
import mapImage from '../../../../assets/map.png';
import { MapInformationContainer, MapTitle } from '../../styles';

interface IMapInformationProps {
  isMobile: boolean;
}

export const MapInformation = ({ isMobile }: IMapInformationProps) => {
  return (
    <MapInformationContainer isMobile={isMobile} className='.font-roboto'>
      <Flex gap='8px'>
        <MapTitle>Map</MapTitle>
        <img src={mapImage} alt='map-image' />
      </Flex>
    </MapInformationContainer>
  );
};
